<template>
  <!-- Innovadis custom: sanitize content slider external URL before binding to href -->
  <a
    v-if="isExternalLink"
    target="_blank"
    class="text-[--color-body] text-sm font-normal"
    rel="noopener noreferrer"
    :href="getSafeUrl(linkUrl as string)"
  >
    {{ linkLabel }}
  </a>
  <router-link v-else :to="linkUrl || '#'">
    <span class="text-[--color-body] text-base font-normal">{{ linkLabel }}</span>
  </router-link>
</template>
<script setup lang="ts">
import { getLinkAttr } from "@/core/utilities/common";
import { getSafeUrl } from "@/core/utilities/url/safeUrl";
import { computed } from "vue";
interface IProps {
  linkLabel: string;
  linkUrl: string;
}

const props = defineProps<IProps>();

const isExternalLink = computed(() => {
  return "externalLink" in getLinkAttr(props.linkUrl);
});
</script>
